import { UserDataActions, UserDataActionTypes } from './user-data.actions';

export const USER_DATA = 'USER_DATA';

export interface UserDataState {
    username: string;
    fullname: string;
}

const initialState = {
    username: 'Annoymous',
    fullname: 'Annoymous',
};

export function userDataReducer(
    state = initialState,
    action: UserDataActions
): UserDataState {
    switch (action.type) {
        case UserDataActionTypes.SetUserName: {
            return { ...state, username: action.payload.username };
        }
        case UserDataActionTypes.SetFullUserName: {
            return { ...state, fullname: action.payload.username };
        }
        case UserDataActionTypes.ClearUserName: {
            return { ...state, username: null };
        }
        default:
            return { ...state };
    }
}
